// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapperC,
.wrapperCMobileView {
  padding-bottom: 10px;
  position: relative;
  min-height: 250px;
}
.wrapperCMobileView {
  max-height: 26.5rem !important;
  overflow-y: auto;
}
.table thead tr th {
  background: #95a2b1;
  color: #fff;
}

.table thead tr th,
.table tbody tr td {
  position: relative;
  border: 1px solid #edf1f7;
  vertical-align: middle;
  /* padding: 0.85em 1.85rem; */
  padding: 0.6em 0.6rem;
  /*  0.358em  */
}
.add {
  position: absolute;
  z-index: 9;
}
.upload {
  position: absolute;
  z-index: 9;
  left: 26px;
}

.delete_tableAction {
  position: absolute;
  left: calc(30rem + 55px);
  z-index: 2;
  top: 0;
  margin-left: 15px;
  display: flex;
}
.additiona-Option.delete_tableAction {
  position: absolute;
  left: calc(30rem + 104px);
  z-index: 2;
  top: 0;
  margin-left: 15px;
  display: flex;
}
.upload-enabled {
  left: calc(30rem + 92px);
}

.delete_tableAction a {
  margin: 0 5px !important;
  padding: 0.52rem 0.75rem;
  color: #fff;
}
.delete_tableAction > ::ng-deep sym-button {
  margin-right: 15px;
}
.delete_tableAction > ::ng-deep sym-button:last-child {
  margin-right: 0;
}
.landing-class.delete_tableAction {
  left: calc(30rem + 55px);
  top: 0;
}
.radioGrp .form-check,
.checkBoxGrp .form-check {
  margin: 0;
}
.checkBoxGrp .form-check > label {
  padding-left: 35px;
}
.delete_tableAction .fgInline {
  padding: 7px 0px 0 0;
}
.thAction > a.thAddRow {
  left: 0;
  width: 40px;
}
.selectQuoteOpt.delete_tableAction {
  left: calc(30rem + 150px);
}

/* # Phone */
@media only screen and (max-width: 320px) {
  .overflowX {
    overflow-x: scroll;
  }
}
/* # Tablet */
@media only screen and (min-width: 321px) and (max-width: 768px) {
  .overflowX {
    overflow-x: scroll;
  }
}
/*
Generic Styling, for Desktops/Laptops
*/
table {
  width: 100% !important;
  border-collapse: collapse;
}
/* Zebra striping */
tr:nth-of-type(odd) {
  background: #eee;
}

/*
Max width before this PARTICULAR table gets nasty
This query will take effect for any screen smaller than 760px
and also iPads specifically.
*/
@media only screen and (max-width: 760px) {
  .table thead tr th,
  .table tbody tr td {
    padding: 0.39em 0.185rem;
  }
  /* Force table to not be like tables anymore */
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    border: 1px solid #ccc;
    position: relative;
  }

  td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-right: 20px !important;
  }
  td.tdTableAction {
    padding-right: 5px !important;
  }
  .table tbody tr td {
    /* text-align: right; */
    /*padding-left: 30px;*/
    min-height: 1.19em;
    display: flex;
    word-break: break-word;
    padding: 5px 5px 5px 5px;
  }

  td:before {
    /* Now like a table header */
    /* position: absolute;
        /* Top/left values mimic padding
        top: 6px;
        left: 0px;
        white-space: nowrap;
        padding-left: 8px; */
    min-width: 40%;
    max-width: 60%;
    padding-right: 5px;
    white-space: normal;
  }

  /*
	Label the data
	*/
  table td::before {
    content: attr(data-label);
    color: #8f9bb3;
    font-size: 0.85rem;
    font-family: 'montserratregular', Arial, Helvetica, sans-serif;
    white-space: normal;
    margin-bottom: 0;
  }

  .table tbody tr td.tdTableAction {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 1;
    border: unset;
  }
  .table tbody tr td.tdTableAction .fgInline > div {
    margin: 0;
  }
  .table tbody tr td.tdTableAction .checkBoxGrp .form-check {
    margin: 0 !important;
  }
  .table tbody tr td.tdTableAction .checkBoxGrp .form-check > label {
    padding-left: 20px;
  }
  .table tbody tr td.tdTableAction .dropdownContainer {
    padding: 0;
  }
  /**table header action css**/
  .add {
    top: 0;
    left: calc(50% + 15px);
  }
  .delete_tableAction {
    position: absolute;
    left: calc(50% + 15px);
    z-index: 2;
    top: 0;
    margin-left: 0;
  }

  .advance-class.delete_tableAction {
    left: calc(50% + 70px);
  }

  .additiona-Option.delete_tableAction {
    top: 42px;
    left: 0;
    margin-left: 0;
  }
  .landing-class.delete_tableAction {
    top: 0;
    left: calc(50% + 15px);
  }
  .sectionContent.overflowX {
    padding: 0 !important;
  }
  .dataTables_wrapper {
    width: 100%;
  }
  .dataTables_wrapper .dataTables_length {
    width: calc(40% - 0px);
    position: relative;
    top: 40px;
  }
  .dataTables_wrapper .dataTables_filter {
    margin: 0 15px 60px 0;
    max-width: 55%;
  }
  .dataTables_wrapper .dataTables_filter label {
    text-align: left;
  }

  .thAction > a.thAddRow {
    left: 0;
  }
  .selectQuoteOpt.delete_tableAction {
    left: 0;
  }
}
a.btn.btn_outline_primary {
  border: #ecf0f6 !important;
  color: #36f;
}
.thAction > a.thAddRow::before {
  line-height: normal;
}
table.dataTable thead th {
  position: relative;
  background-image: none !important;
}

table.dataTable thead th.sorting:after,
table.dataTable thead th.sorting_asc:after,
table.dataTable thead th.sorting_desc:after {
  position: absolute;
  top: 12px;
  right: 8px;
  display: block;
  font-family: FontAwesome;
}

table.dataTable thead th.sorting:after {
  content: '\\f0dc';
  color: #ddd;
  font-size: 0.8em;
  padding-top: 0.12em;
}
table.dataTable thead th.sorting_asc:after {
  content: '\\f0de';
}
table.dataTable thead th.sorting_desc:after {
  content: '\\f0dd';
}
a.link {
  color: #007bff;
  cursor: pointer;
}

.advanceSearch {
  position: absolute;
  top: 48px;
  left: 15px;
  width: 50%;
  z-index: 10;
  background: #edf1f7;
  border: 1px solid #507bbb;
}
.advanceSearch::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: calc(100% - 30%) !important;
  margin-left: 0px;
  border-width: 12px;
  border-style: solid;
  border-color: transparent transparent #507bbb transparent;
}

.advanceSearchConfirm {
  bottom: 0;
  padding: 0.9rem 0 0 0;
  min-width: 90%;
  right: 0;
}

.flex {
  display: flex;
}

.flex .ng-select {
  width: 100%;
}

@media only screen and (max-width: 768px) {
  .advanceSearch {
    top: 51px;
    left: 0px;
    width: calc(100% - 8%) !important;

    z-index: 9;
  }
  .advanceSearch::after {
    left: calc(100% - 50%) !important;
  }
}
.select_th_col {
  width: 0px !important;
}

.mt-displaySelectOption {
  margin-top: calc(100px - 10px);
}
.search_footer {
  position: inherit !important;
  background: transparent !important;
  box-shadow: none !important;
}
/*
.searchColumn-wrap {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}*/

.thAction.sorting,
.thAction.sorting_asc,
.thAction.sorting_desc {
  pointer-events: none; /* Disable pointer to prevent sorting for Action Header */
}
.thAction.sorting::before,
.thAction.sorting_asc::before,
.thAction.sorting_desc::before {
  content: none; /* Removed the sort icon for Action Header*/
}
select {
  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%);
  background-position: calc(100% - 10px) calc(1em + 2px), calc(100% - 5px) calc(1em + 2px);
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  padding: 8px 16px 5px 6px;
  border-radius: 0.295em;
}
select:focus {
  background-image: linear-gradient(45deg, #333 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, #333 50%);
  background-position: calc(100% - 5px) 1em, calc(100% - 10px) 1em;
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  padding: 8px 16px 5px 6px;
  border-radius: 0.295em;
  outline: 0;
}

.footer {
  position: relative;
  top: 0.97rem;
  right: 0.1rem;
  float: right;
}

.mt-6 {
  margin-top: 4.9rem;
}

@media only screen and (max-width: 767px) {
  .footer {
    margin: 0px 0px 8px 0px;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 834px) {
  .selectQuoteOpt.delete_tableAction,
  .additiona-Option.delete_tableAction {
    top: 5%;
    left: 0px;
    margin-top: 7px;
  }
  .delete_tableAction {
    left: 54%;
  }
}

@media only screen and (min-width: 567px) {
  .mt-displaySelectOption {
    margin-top: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/system-common/search/search.component.css"],"names":[],"mappings":"AAAA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;EACV,MAAM;EACN,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,MAAM;EACN,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,MAAM;AACR;AACA;;EAEE,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE;IACE,kBAAkB;EACpB;AACF;AACA,aAAa;AACb;EACE;IACE,kBAAkB;EACpB;AACF;AACA;;CAEC;AACD;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;;;;CAIC;AACD;EACE;;IAEE,wBAAwB;EAC1B;EACA,8CAA8C;EAC9C;;;;;;IAME,cAAc;EAChB;;EAEA,mEAAmE;EACnE;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;IAC5B;;;;;4BAKwB;IACxB,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;EAEA;EACA;IACE,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,8DAA8D;IAC9D,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA,4BAA4B;EAC5B;IACE,MAAM;IACN,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,MAAM;IACN,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAS;IACT,OAAO;IACP,cAAc;EAChB;EACA;IACE,MAAM;IACN,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,qBAAqB;IACrB,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,OAAO;EACT;EACA;IACE,OAAO;EACT;AACF;AACA;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;;;EAGE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,SAAS;IACT,SAAS;IACT,iCAAiC;;IAEjC,UAAU;EACZ;EACA;IACE,iCAAiC;EACnC;AACF;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;;;;;EAKE;;AAEF;;;EAGE,oBAAoB,EAAE,yDAAyD;AACjF;AACA;;;EAGE,aAAa,EAAE,2CAA2C;AAC5D;AACA;EACE;sDACoD;EACpD,wFAAwF;EACxF,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE;sDACoD;EACpD,gEAAgE;EAChE,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;;IAEE,OAAO;IACP,SAAS;IACT,eAAe;EACjB;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".wrapperC,\n.wrapperCMobileView {\n  padding-bottom: 10px;\n  position: relative;\n  min-height: 250px;\n}\n.wrapperCMobileView {\n  max-height: 26.5rem !important;\n  overflow-y: auto;\n}\n.table thead tr th {\n  background: #95a2b1;\n  color: #fff;\n}\n\n.table thead tr th,\n.table tbody tr td {\n  position: relative;\n  border: 1px solid #edf1f7;\n  vertical-align: middle;\n  /* padding: 0.85em 1.85rem; */\n  padding: 0.6em 0.6rem;\n  /*  0.358em  */\n}\n.add {\n  position: absolute;\n  z-index: 9;\n}\n.upload {\n  position: absolute;\n  z-index: 9;\n  left: 26px;\n}\n\n.delete_tableAction {\n  position: absolute;\n  left: calc(30rem + 55px);\n  z-index: 2;\n  top: 0;\n  margin-left: 15px;\n  display: flex;\n}\n.additiona-Option.delete_tableAction {\n  position: absolute;\n  left: calc(30rem + 104px);\n  z-index: 2;\n  top: 0;\n  margin-left: 15px;\n  display: flex;\n}\n.upload-enabled {\n  left: calc(30rem + 92px);\n}\n\n.delete_tableAction a {\n  margin: 0 5px !important;\n  padding: 0.52rem 0.75rem;\n  color: #fff;\n}\n.delete_tableAction > ::ng-deep sym-button {\n  margin-right: 15px;\n}\n.delete_tableAction > ::ng-deep sym-button:last-child {\n  margin-right: 0;\n}\n.landing-class.delete_tableAction {\n  left: calc(30rem + 55px);\n  top: 0;\n}\n.radioGrp .form-check,\n.checkBoxGrp .form-check {\n  margin: 0;\n}\n.checkBoxGrp .form-check > label {\n  padding-left: 35px;\n}\n.delete_tableAction .fgInline {\n  padding: 7px 0px 0 0;\n}\n.thAction > a.thAddRow {\n  left: 0;\n  width: 40px;\n}\n.selectQuoteOpt.delete_tableAction {\n  left: calc(30rem + 150px);\n}\n\n/* # Phone */\n@media only screen and (max-width: 320px) {\n  .overflowX {\n    overflow-x: scroll;\n  }\n}\n/* # Tablet */\n@media only screen and (min-width: 321px) and (max-width: 768px) {\n  .overflowX {\n    overflow-x: scroll;\n  }\n}\n/*\nGeneric Styling, for Desktops/Laptops\n*/\ntable {\n  width: 100% !important;\n  border-collapse: collapse;\n}\n/* Zebra striping */\ntr:nth-of-type(odd) {\n  background: #eee;\n}\n\n/*\nMax width before this PARTICULAR table gets nasty\nThis query will take effect for any screen smaller than 760px\nand also iPads specifically.\n*/\n@media only screen and (max-width: 760px) {\n  .table thead tr th,\n  .table tbody tr td {\n    padding: 0.39em 0.185rem;\n  }\n  /* Force table to not be like tables anymore */\n  table,\n  thead,\n  tbody,\n  th,\n  td,\n  tr {\n    display: block;\n  }\n\n  /* Hide table headers (but not display: none;, for accessibility) */\n  thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n\n  tr {\n    border: 1px solid #ccc;\n    position: relative;\n  }\n\n  td {\n    /* Behave  like a \"row\" */\n    border: none;\n    border-bottom: 1px solid #eee;\n    position: relative;\n    padding-right: 20px !important;\n  }\n  td.tdTableAction {\n    padding-right: 5px !important;\n  }\n  .table tbody tr td {\n    /* text-align: right; */\n    /*padding-left: 30px;*/\n    min-height: 1.19em;\n    display: flex;\n    word-break: break-word;\n    padding: 5px 5px 5px 5px;\n  }\n\n  td:before {\n    /* Now like a table header */\n    /* position: absolute;\n        /* Top/left values mimic padding\n        top: 6px;\n        left: 0px;\n        white-space: nowrap;\n        padding-left: 8px; */\n    min-width: 40%;\n    max-width: 60%;\n    padding-right: 5px;\n    white-space: normal;\n  }\n\n  /*\n\tLabel the data\n\t*/\n  table td::before {\n    content: attr(data-label);\n    color: #8f9bb3;\n    font-size: 0.85rem;\n    font-family: 'montserratregular', Arial, Helvetica, sans-serif;\n    white-space: normal;\n    margin-bottom: 0;\n  }\n\n  .table tbody tr td.tdTableAction {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    z-index: 1;\n    border: unset;\n  }\n  .table tbody tr td.tdTableAction .fgInline > div {\n    margin: 0;\n  }\n  .table tbody tr td.tdTableAction .checkBoxGrp .form-check {\n    margin: 0 !important;\n  }\n  .table tbody tr td.tdTableAction .checkBoxGrp .form-check > label {\n    padding-left: 20px;\n  }\n  .table tbody tr td.tdTableAction .dropdownContainer {\n    padding: 0;\n  }\n  /**table header action css**/\n  .add {\n    top: 0;\n    left: calc(50% + 15px);\n  }\n  .delete_tableAction {\n    position: absolute;\n    left: calc(50% + 15px);\n    z-index: 2;\n    top: 0;\n    margin-left: 0;\n  }\n\n  .advance-class.delete_tableAction {\n    left: calc(50% + 70px);\n  }\n\n  .additiona-Option.delete_tableAction {\n    top: 42px;\n    left: 0;\n    margin-left: 0;\n  }\n  .landing-class.delete_tableAction {\n    top: 0;\n    left: calc(50% + 15px);\n  }\n  .sectionContent.overflowX {\n    padding: 0 !important;\n  }\n  .dataTables_wrapper {\n    width: 100%;\n  }\n  .dataTables_wrapper .dataTables_length {\n    width: calc(40% - 0px);\n    position: relative;\n    top: 40px;\n  }\n  .dataTables_wrapper .dataTables_filter {\n    margin: 0 15px 60px 0;\n    max-width: 55%;\n  }\n  .dataTables_wrapper .dataTables_filter label {\n    text-align: left;\n  }\n\n  .thAction > a.thAddRow {\n    left: 0;\n  }\n  .selectQuoteOpt.delete_tableAction {\n    left: 0;\n  }\n}\na.btn.btn_outline_primary {\n  border: #ecf0f6 !important;\n  color: #36f;\n}\n.thAction > a.thAddRow::before {\n  line-height: normal;\n}\ntable.dataTable thead th {\n  position: relative;\n  background-image: none !important;\n}\n\ntable.dataTable thead th.sorting:after,\ntable.dataTable thead th.sorting_asc:after,\ntable.dataTable thead th.sorting_desc:after {\n  position: absolute;\n  top: 12px;\n  right: 8px;\n  display: block;\n  font-family: FontAwesome;\n}\n\ntable.dataTable thead th.sorting:after {\n  content: '\\f0dc';\n  color: #ddd;\n  font-size: 0.8em;\n  padding-top: 0.12em;\n}\ntable.dataTable thead th.sorting_asc:after {\n  content: '\\f0de';\n}\ntable.dataTable thead th.sorting_desc:after {\n  content: '\\f0dd';\n}\na.link {\n  color: #007bff;\n  cursor: pointer;\n}\n\n.advanceSearch {\n  position: absolute;\n  top: 48px;\n  left: 15px;\n  width: 50%;\n  z-index: 10;\n  background: #edf1f7;\n  border: 1px solid #507bbb;\n}\n.advanceSearch::after {\n  content: '';\n  position: absolute;\n  bottom: 100%;\n  left: calc(100% - 30%) !important;\n  margin-left: 0px;\n  border-width: 12px;\n  border-style: solid;\n  border-color: transparent transparent #507bbb transparent;\n}\n\n.advanceSearchConfirm {\n  bottom: 0;\n  padding: 0.9rem 0 0 0;\n  min-width: 90%;\n  right: 0;\n}\n\n.flex {\n  display: flex;\n}\n\n.flex .ng-select {\n  width: 100%;\n}\n\n@media only screen and (max-width: 768px) {\n  .advanceSearch {\n    top: 51px;\n    left: 0px;\n    width: calc(100% - 8%) !important;\n\n    z-index: 9;\n  }\n  .advanceSearch::after {\n    left: calc(100% - 50%) !important;\n  }\n}\n.select_th_col {\n  width: 0px !important;\n}\n\n.mt-displaySelectOption {\n  margin-top: calc(100px - 10px);\n}\n.search_footer {\n  position: inherit !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n/*\n.searchColumn-wrap {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: break-word;\n}*/\n\n.thAction.sorting,\n.thAction.sorting_asc,\n.thAction.sorting_desc {\n  pointer-events: none; /* Disable pointer to prevent sorting for Action Header */\n}\n.thAction.sorting::before,\n.thAction.sorting_asc::before,\n.thAction.sorting_desc::before {\n  content: none; /* Removed the sort icon for Action Header*/\n}\nselect {\n  background-image: linear-gradient(45deg, transparent 50%, gray 50%),\n    linear-gradient(135deg, gray 50%, transparent 50%);\n  background-position: calc(100% - 10px) calc(1em + 2px), calc(100% - 5px) calc(1em + 2px);\n  background-size: 5px 5px, 5px 5px;\n  background-repeat: no-repeat;\n  padding: 8px 16px 5px 6px;\n  border-radius: 0.295em;\n}\nselect:focus {\n  background-image: linear-gradient(45deg, #333 50%, transparent 50%),\n    linear-gradient(135deg, transparent 50%, #333 50%);\n  background-position: calc(100% - 5px) 1em, calc(100% - 10px) 1em;\n  background-size: 5px 5px, 5px 5px;\n  background-repeat: no-repeat;\n  padding: 8px 16px 5px 6px;\n  border-radius: 0.295em;\n  outline: 0;\n}\n\n.footer {\n  position: relative;\n  top: 0.97rem;\n  right: 0.1rem;\n  float: right;\n}\n\n.mt-6 {\n  margin-top: 4.9rem;\n}\n\n@media only screen and (max-width: 767px) {\n  .footer {\n    margin: 0px 0px 8px 0px;\n  }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 834px) {\n  .selectQuoteOpt.delete_tableAction,\n  .additiona-Option.delete_tableAction {\n    top: 5%;\n    left: 0px;\n    margin-top: 7px;\n  }\n  .delete_tableAction {\n    left: 54%;\n  }\n}\n\n@media only screen and (min-width: 567px) {\n  .mt-displaySelectOption {\n    margin-top: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
